/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setloading, notloading } from "../../actions";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import Swal from "sweetalert2";
import SendIcon from "@material-ui/icons/Send";
import axios from "axios";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { Button, Grid, Paper, Typography, MenuItem } from "@material-ui/core";
import { TextField } from "formik-material-ui";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
const BedCapacity = (props) => {
  const dispatch = useDispatch();
  const [details, setdetails] = useState([]);
  const [reportingYears, setreportingYears] = useState([]);

  const [oldReportingYear, setoldReportingYear] = useState("");
  const [Id, setId] = useState("");

  var settingsE = localStorage.getItem("settings");
  var settings = CryptoAES.decrypt(settingsE.toString(), "cbs211&213&215");
  var s = JSON.parse(settings.toString(CryptoENC));
  const serverUrl = s.serverUrl;
  const facilityname = s.facilityName;

  var userdetails = localStorage.getItem("userdetails");
  var udetails = CryptoAES.decrypt(userdetails.toString(), "cbs211&213&215");
  var u = JSON.parse(udetails.toString(CryptoENC));

  const userFullname = u.userFullname;
  const facilitycode = u.facilitycode;
  const username = u.username;

  const [firstLoad, setfirstLoad] = useState(true);
  const [isEdit, setisEdit] = useState(false);

  useEffect(() => {
    if (firstLoad) {
      handlegetTableRecords("tblreportingyear");

      if (Id !== "") {
        setisEdit(true);
        handleGetDetails();
      }

      setfirstLoad(false);
      console.log(details);
    }
  }, [firstLoad]);

  const classes = useStyles();
  function handleGetDetails() {
    axios
      .get(serverUrl + "/api/gettablerecords", {
        params: {
          q: "select * from tblBedCapacity where id='" + Id + "'",
        },
      })
      .then((res) => {
        if (res.data.length > 0) {
          setdetails(res.data[0]);

          setisEdit(true);
        } else {
          setisEdit(false);
        }

        dispatch(notloading());
      })
      .catch((error) => {
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  }

  function handleInitialValues() {
    return {
      ReportingYear: isEdit ? details.ReportingYear : "",
      AuthorizedBedCapacity: isEdit ? details.AuthorizedBedCapacity : "",
      ImplementingBeds: isEdit ? details.ImplementingBeds : "",
    };
  }

  const handlegetTableRecords = (tblName) => {
    let q = "";

    q = "select * from " + tblName + " order by id";

    axios
      .get(serverUrl + "/api/gettablerecords", {
        params: {
          q: q,
        },
      })
      .then((res) => {
        if (tblName === "tblreportingyear") {
          setreportingYears(res.data);
        }
        dispatch(notloading());
      })
      .catch((error) => {
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  };

  function validateFields(values) {
    const errors: Partial<Values> = {};
    if (values.ReportingYear === "" || values.ReportingYear === null) {
      errors.ReportingYear = "Please select reporting year!";
    }

    if (!values.AuthorizedBedCapacity) {
      errors.AuthorizedBedCapacity = "This field is required!";
    }

    if (!values.ImplementingBeds) {
      errors.ImplementingBeds = "This field is required!";
    }

    return errors;
  }
  function handleReportingYearChange(values) {
    if (values.ReportingYear === "") return;
    if (values.ReportingYear === oldReportingYear) return;
    setoldReportingYear(values.ReportingYear);

    let q = "";

    q =
      "select * from tblBedCapacity where reportingyear='" +
      values.ReportingYear +
      "' and facilitycode='" +
      facilitycode +
      "'";

    axios
      .get(serverUrl + "/api/gettablerecords", {
        params: {
          q: q,
        },
      })
      .then((res) => {
        if (res.data.length > 0) {
          setdetails(res.data[0]);
          setId(res.data[0].Id);

          setisEdit(true);
        } else {
          setId("");
          setisEdit(false);
        }

        dispatch(notloading());
      })
      .catch((error) => {
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  }

  function submitForm(values, { setSubmitting, resetForm }) {
    dispatch(setloading());

    var serverUrl = localStorage.getItem("serverUrl");
    var token = localStorage.getItem("token_id");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;

    const valuestosave = {
      ...values,
      userFullname: userFullname,
      username: username,
      Id: Id,
    };
    // .post(serverUrl + "/api/savebedcapacity", valuestosave)
    axios
      .post(serverUrl + "/api/savebedcapacity", valuestosave)
      .then((res) => {
        if (res.data.Status === 1) {
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              dispatch(notloading());

              props.history.push("/");
            }
          });
        } else {
          dispatch(notloading());
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "warning",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }
        setSubmitting(false);
      })
      .catch((error) => {
        dispatch(notloading());
        setSubmitting(false);
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      })
      .finally(function () {});
  }
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2}></Grid>
        <Grid item xs={12} sm={8}>
          <Paper className={classes.root}>
            <Typography variant="h5" component="h3" align="center">
              Bed Capacity/Occupancy
            </Typography>

            <Formik
              enableReinitialize
              initialValues={handleInitialValues()}
              validate={(values) => validateFields(values)}
              onSubmit={(values, { setSubmitting, resetForm }) =>
                submitForm(values, { setSubmitting, resetForm })
              }
              render={({
                submitForm,
                isSubmitting,
                values,
                setFieldValue,
                touched,
              }) => (
                <Form>
                  <Field
                    type="text"
                    label="Reporting Year"
                    select
                    margin="dense"
                    component={TextField}
                    fullWidth
                    onChange={handleReportingYearChange(values)}
                    values={values.ReportingYear}
                    required={true}
                    name="ReportingYear"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    {reportingYears.map((option) => (
                      <MenuItem
                        key={option.ReportingYear}
                        value={option.ReportingYear}
                      >
                        {option.ReportingYear}
                      </MenuItem>
                    ))}
                  </Field>
                  <Field
                    type="number"
                    label="Authorized Bed Capacity"
                    name="AuthorizedBedCapacity"
                    placeholder="Authorized Bed Capacity"
                    component={TextField}
                    margin="dense"
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: values.AuthorizedBedCapacity !== "",
                    }}
                  />
                  <Field
                    type="number"
                    label="Implementing Beds"
                    name="ImplementingBeds"
                    placeholder="Authorized Bed Capacity"
                    component={TextField}
                    margin="dense"
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: values.ImplementingBeds !== "",
                    }}
                  />

                  <div className={classes.wrapper}>
                    <div className={classes.buttons}>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                        onClick={submitForm}
                      >
                        <SendIcon className={classes.leftIcon} />
                        Submit
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} sm={2}></Grid>
      </Grid>
    </div>
  );
};

export default withRouter(BedCapacity);
